export default "static/src/images/I-corsi2_red.jpg";